module.exports = __webpack_public_path__ + "img/borderEllipseWhite.fdb90af8.svg";